export default __webpack_public_path__ + "media/images/images/raty/heart-3fea39cff4dc6381dc4a89619215fcae.png";